import type { NodeEnv } from '.';

/** running application environment, eg staging or production */
export const ENV = (process.env.APP_ENV ?? 'development') as NodeEnv;
// uncomment to enable production preview locally
// export const ENV = 'production' as NodeEnv;

/** clarity app id */
export const CLARITY = process.env.CLARITY ?? 'dummy';

/** google analytics id */
export const GOOGLE = process.env.GOOGLE ?? 'dummy';

/** google tag manager id */
export const GTM = process.env.GTM ?? 'dummy';

/** onshape app id */
export const ONSHAPE_CLIENT_ID = process.env.ONSHAPE_CLIENT_ID ?? 'dummy';

/** stripe pricing table id (default and for Onshape) */
export const STRIPE_PRICING_TABLE = process.env.STRIPE_PRICING_TABLE ?? 'dummy';
export const STRIPE_PRICING_TABLE_ONSHAPE = process.env.STRIPE_PRICING_TABLE_ONSHAPE ?? 'dummy';

/** stripe public key */
export const STRIPE_PUBLIC = process.env.STRIPE_PUBLIC ?? 'dummy';
